import { useContext } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom'; // Zastępuje useNavigate
import { useTranslation } from 'react-i18next'; // Zastępuje falcon-i18n
import { usePopup } from '../context/PopupContext';
import { useUserContext } from '../context/UserContext';
import { ADD_PRODUCT_TO_WISHLIST, GET_WISHLIST_PRODUCTS, REMOVE_PRODUCT_FROM_WISHLIST } from '../queries/wishlist';
import { useCartContext } from '../context/CartContext';
import { addToWishListEvent } from '../hooks/useAnalytics';

const useWishlist = (sku, name, id, price) => {
  const { t } = useTranslation();
  const { user, wishlist , refetchWishlist} = useUserContext();
  const { updateCartItem } = useCartContext();
  const navigate = useNavigate();
  const { showAddToCartPopupMessage } = usePopup();

  // Upewnij się, że SKU jest zdefiniowane
  const safeSkuValue = sku || '';
  const safeNameValue = name || '';
  
  const [addToWishlist, { loading: addLoading }] = useMutation(ADD_PRODUCT_TO_WISHLIST, {
    awaitRefetchQueries: true,
    onCompleted:()=>{
      refetchWishlist()
    }
  });

  const [removeFromWishlist, { loading: removeLoading }] = useMutation(REMOVE_PRODUCT_FROM_WISHLIST, {
    awaitRefetchQueries: true,
    onCompleted: (data) => {
      refetchWishlist()
    }
  });

  // Bezpieczne pobieranie danych z wishlistData
  // const wishlist = wishlistData?.getWishlistProducts?.wishlists?.[0] || null;
  // const wishlistItems = wishlist?.items_v2?.items || [];
  // Znajdź element listy życzeń, ale tylko jeśli mamy poprawne SKU
  const wishlistItem = safeSkuValue 
    ? wishlist?.items_v2?.items.find(item => item?.product?.sku === safeSkuValue)
    : null;
    
  // const loading = queryLoading || addLoading || removeLoading;

  const toggleInWishlist = async (event) => {
    // Upewnij się, że event jest dostępny
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    // Walidacja danych
    if (!safeSkuValue) {
      console.error('Nie można dodać przedmiotu do listy życzeń: brak SKU');
      return;
    }

    if (!user) {
      navigate('/customer/account');
      return;
    }


    if (!wishlist?.id) {
      showAddToCartPopupMessage(t('wishlist.noWishlistError'), 'error', 2000);
      return;
    }

    try {
      if (wishlistItem) {
        await removeFromWishlist({
          variables: { wishlistId: wishlist.id, wishlistItemsIds: wishlistItem.id },
        });
        
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new CustomEvent('wishlist_remove', {}));
        }
        
        showAddToCartPopupMessage(`${safeNameValue} ${t('cart.removedFromWishlist')}`, 'success', 2000);
      } else {
        await addToWishlist({
          variables: { wishlistId: wishlist.id, wishlistItems: { sku: safeSkuValue, quantity: 1 } },
        });
        
        if (id) {
          updateCartItem(id, 0);
        }
        
        showAddToCartPopupMessage(`${safeNameValue} ${t('cart.movedToWishlist')}`, 'success', 2000);
        
        // Wywołaj zdarzenie analityczne tylko jeśli wszystkie dane są dostępne
        if (price) {
          addToWishListEvent(safeSkuValue, safeNameValue, price);
        }
      }
    } catch (err) {
      console.error('Błąd operacji na liście życzeń:', err);
      showAddToCartPopupMessage(t('wishlist.error'), 'error', 2000);
    }
  };

  return { 
    toggleInWishlist, 
    isInWishlist: !!wishlistItem,
  };
};

export default useWishlist;